import { Route, Routes } from 'react-router-dom';
import './App.css';
import Blogs from './Components/Blogs/Blogs';
import Home from './Components/Home/Home'
import Header from './Components/Header/Header'
import Footer from './Components/Footer/Footer'
import Login from './Components/Login/Login';
import PageNotFound from './Components/PageNotFound/PageNotFound';
import Services from './Components/Services/Services'
import SignUp from './Components/SignUp/SignUp';
import StudentReviews from './Components/StudentReviews/StudentReviews';
import CheckOut from './Components/CheckOut/CheckOut';
import AboutMe from './Components/AboutMe/AboutMe';
import RequireAuth from './Components/RequireAuth/RequireAuth';



function App() {
  return (
    <div className='position-relative'>
      <Header></Header>
      <Routes>
        <Route path='/' element={<Home></Home>}></Route>
        <Route path='/home' element={<Home></Home>}></Route>
        <Route path='/services' element={<Services></Services>}></Route>
        <Route path='/reviews' element={<StudentReviews></StudentReviews>}></Route>
        
        <Route path='/checkout' element={
        <RequireAuth>
          <CheckOut></CheckOut> 
          </RequireAuth>}>

        </Route>


        <Route path='/blogs' element={<Blogs></Blogs>}></Route>
        <Route path='/about' element={<AboutMe></AboutMe>}></Route>
        <Route path='/login' element={<Login></Login>}></Route>
        <Route path='/signup' element={<SignUp></SignUp>}></Route>
        <Route path='*' element={<PageNotFound></PageNotFound>}></Route>
      </Routes>
      <Footer></Footer>
    </div>
  );
}

export default App;